import React from 'react';
import Home from '../../components/customer/Home';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';

const HomePage = () => {
  return (
    <>
      <Navbar />
      <Home />
      <Footer />
    </>
  );
};

export default HomePage;